import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = (n) => (_pushScopeId("data-v-5b57d538"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "NavMenu",
  class: "flex bgColorFFF"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
/*#__PURE__*/_createElementVNode("div", { style: { "font-weight": "bold", "font-size": "22px", "width": "112px", "margin-top": "15px" } }, "乙十睡眠"),
/*#__PURE__*/_createElementVNode("div", { style: { "font-size": "14px", "color": "#999999" } }, "YISHI SLEEP")],
-1));
const _hoisted_3 = { class: "el-sub-menu-title" };
const _hoisted_4 = { class: "el-menu-title" };
const _hoisted_5 = {
  key: 1,
  class: "el-menu-title"
};
const _hoisted_6 = { class: "el-menu-title" };
const _hoisted_7 = { class: "el-sub-menu-title" };

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [
  _createElementVNode("div", {
    class: "flex",
    style: { "height": "100%", "margin-right": "7%", "margin-left": "17%", "cursor": "pointer" },
    onClick: _cache[0] || (_cache[0] = ($event) => $options.backToHome())
  }, [
  _createVNode(_component_el_image, {
    style: { "width": "50px", "height": "50px", "margin-top": "15px" },
    src: "https://oss.bioyishi.com/imgs/yssm_circular.png",
    fit: "fill",
    loading: "lazy"
  }),
  _hoisted_2]
  ),
  _createVNode(_component_el_menu, {
    "default-active": $data.activeIndex,
    class: "el-menu-demo",
    mode: "horizontal",
    onSelect: $options.handleSelect,
    "text-color": "#333333",
    "active-text-color": "#EC7600"
  }, {
    default: _withCtx(() => [(
    _openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.navMenuData, (item, index) => {
      return _openBlock(), _createElementBlock(_Fragment, { key: index }, [
      item.child ? (
      _openBlock(), _createBlock(_component_el_sub_menu, {
        key: 0,
        index: item.index,
        class: "el-sub-menu-demo",
        onClick: ($event) => $options.handClick(item.index, item.child[0].index, false)
      }, {
        title: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1)]
        ),
        default: _withCtx(() => [(
        _openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.child, (childItem, childIndex) => {
          return _openBlock(), _createElementBlock(_Fragment, { key: childIndex }, [
          childItem.child ? (
          _openBlock(), _createBlock(_component_el_sub_menu, {
            key: 0,
            index: childItem.index
          }, {
            title: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(childItem.name), 1)]
            ),
            default: _withCtx(() => [(
            _openBlock(true), _createElementBlock(_Fragment, null, _renderList(childItem.child, (sonChildItem, sonChildIndex) => {
              return _openBlock(), _createBlock(_component_el_menu_item, {
                key: sonChildIndex,
                index: sonChildItem.index,
                onClick: ($event) => $options.handClick(item.index, sonChildItem.index, true)
              }, {
                default: _withCtx(() => [
                sonChildItem.showImg ? (
                _openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  src: sonChildItem.name,
                  style: { "left": "0px", "position": "absolute" }
                }, null, 8, ["src"])) : (
                _openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(sonChildItem.name), 1))]
                ),
                _: 2
              }, 1032, ["index", "onClick"]);
            }), 128))]
            ),
            _: 2
          }, 1032, ["index"])) : (
          _openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            index: childItem.index,
            onClick: ($event) => $options.handClick(item.index, childItem.index, true)
          }, {
            default: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(childItem.name), 1)]
            ),
            _: 2
          }, 1032, ["index", "onClick"]))],
          64);
        }), 128))]
        ),
        _: 2
      }, 1032, ["index", "onClick"])) : (
      _openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        class: "el-menu-item-demo",
        index: item.index
      }, {
        default: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1)]
        ),
        _: 2
      }, 1032, ["index"]))],
      64);
    }), 128))]
    ),
    _: 1
  }, 8, ["default-active", "onSelect"])]
  );
}